import "./styles.scss";
import React, { useState, useEffect } from "react";
import {
	Col,
	Container,
	Row,
	Card,
	CardBody,
	CardText,
	Nav,
	NavItem,
	NavLink,
	Media,
	CardImg,
} from "reactstrap";
import "assets/scss/website/app.scss";
import Carousel from "react-multi-carousel";
import classnames from "classnames";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import { Link } from "react-router-dom";
import TablePayment from "./TablePayment";
import "react-multi-carousel/lib/styles.css";
import compoundImg from "assets/images/bg.png";
import PropertyService from "services/Website/PropertyService";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import MyMap from "components/Common/google-map/MyMap";
import devCompound from "assets/images/Dev_Compound.png";
import imgError from "assets/images/profile-img.png";
import devBuilding from "assets/images/Dev_Building.png";
import devProperty from "assets/images/Dev_Property.png";
import developerdImg from "assets/images/developer_logo.png";
import { addInterest } from "store/Auth/actions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import InterestServices from "services/Website/InterestServices";
import { useTranslation } from "react-i18next";
import Skeleton from "components/Website/Skeleton";
import http from "services/HttpService";
import Select from "react-select";
import { appendFilters } from "store/actions";
import ReactWhatsapp from "react-whatsapp";
import Spinner2 from "components/Website/Spinner2";
import InterActiveModeService from "services/Admin/InterActiveModeService";
import { appendData } from "store/Mode/actions";
import InteractiveMode from "./InteractiveMode";
import AlbumModal from "../CompoundDetails/Modal/AlbumModal";
import MessageModal from "../CompoundDetails/Modal/MessageModal";
import CallModal from "../CompoundDetails/Modal/CallModal";
// import amenities from "assets/images/amenities.png";

const options = {
	year: "numeric",
	month: "short",
};

const PropertyDetails = (props) => {
	const [callModal, setCallModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);
	const { id } = props.match.params;
	const { t } = useTranslation();
	const interestServices = new InterestServices();
	const propertyService = new PropertyService();
	const [albumModal, setAlbumModal] = useState(false);
	const [activePatmentPlan, setActivePatmentPlan] = useState(null);
	const [activeElevate, setActiveElevate] = useState({
		down_payment: 0,
		discount: 0,
	});
	const [exchangeRate, setExchangeRate] = useState({});
	const [activeYear, setActiveYear] = useState([]);
	const [activeYears, setActiveYears] = useState(0);
	const [propertyDetails, setPropertyDetails] = useState({});
	const [activeYearNumber, setActiveYearNumber] = useState(0);
	const [items, setItems] = useState([]);
	const [mapRender, setMapRender] = useState(0);
	const [interestLoading, setInterestLoading] = useState(false);
	const [frequencyOptions, setFrequencyOptions] = useState([]);
	const [frequency, setFrequency] = useState();
	const [depositIndex, setDepositIndex] = useState(0);
	const [DetailsLoading, setDetailsLoading] = useState(true);
	const [notFound, setNotFound] = useState(false);
	const [totalOffPayments, setTotalOffPayments] = useState({});
	const [showHighlight, setshowHighlight] = useState(false);
	const [loadedMasterImg, setLoadedMasterImg] = useState(false);
	const [loadingInteractive, setLoadingIntractive] = useState(false);
	const [showInteractive, setShowInteractive] = useState(false);
	const [hasInteractive, setHasInteractive] = useState(false);
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const filterData = useSelector((state) => state.filter);
	const modeData = useSelector((state) => state.Mode);
	const dispatch = useDispatch();

	const isInterested = () => {
		const id = parseInt(propertyDetails?.id);
		return AuthData.interestsUnits.includes(id);
	};

	const videoResponsive = {
		superLargeDesktop: {
			breakpoint: { max: 4000, min: 3000 },
			items: 1,
			slidesToSlide: 1,
		},
		desktopLg: {
			breakpoint: { max: 3000, min: 1300 },
			items: 1,
			slidesToSlide: 1,
		},
		desktop: {
			breakpoint: { max: 1300, min: 1100 },
			items: 1,
			slidesToSlide: 1,
		},
		tablet: {
			breakpoint: { max: 1100, min: 600 },
			items: 1,
			slidesToSlide: 1,
		},
		mobile: {
			breakpoint: { max: 600, min: 0 },
			items: 1,
			slidesToSlide: 1,
		},
	};
	useEffect(() => {
		http.setLang();
		propertyService.find(id).then((response) => {
			if (response === "Unit Not Found !") {
				setNotFound(true);
				setDetailsLoading(false);
			}
			if (response && response?.status === SuccessOk) {
				setPropertyDetails(response.data);
				setTotalOffPayments({ ...response?.data?.total_off_payments });
				response.data.payment_plans.sort(
					(a, b) => a.years.length - b.years.length
				);
				let exchangeRateRes = response?.data?.exchangeRate;
				setExchangeRate(response?.data?.exchangeRate);
				const updatedPlans = response.data.payment_plans.map((plan) => {
					return {
						...plan,
						years: plan.years.map((year, index) => {
							let payableYear =
								Number(year.total) +
								(index === 0 ? Number(plan?.down_payment_amount) : 0);
							// for (const key in year.years) {
							//   const month = year.years[key]
							//   if (month ?.off_payment ) {
							//     month ?.off_payment.forEach(item => {
							//       payableYear = payableYear + Number(item.payment_fees)
							//       // payableYear = payableYear + Number(item.payment_fees)
							//     })
							//   }
							//  }
							return {
								...year,
								total: payableYear,
							};
						}),
					};
				});
				const data = updatedPlans[0];
				setActivePatmentPlan({ ...data });
				// if(data?.link_down_payment && !!data?.elevate_down_payment?.length){
				//   setActiveElevate(data?.elevate_down_payment[0])
				// }
				if (
					!!Number(response.data.coumound.lang) &&
					!!Number(response.data.coumound.lat)
				)
					setMapRender(mapRender + 1);
				setDetailsLoading(false);
			}
		});
	}, [AuthData?.currency?.currency_code]);

	useEffect(() => {
		setFrequency("");
		if (activeYears !== -1) {
			let options = [];

			propertyDetails.payment_plans?.map((plan, index) => {
				let itemPlan = [plan.years[0]];
				if (activeYears == index) {
					itemPlan?.map((year) => {
						Object.keys(year.years).forEach((yearKey, yearKeyIndex) => {
							if (yearKeyIndex == 11) {
								Object.keys(year.years[yearKey]).forEach((key) => {
									if (year.years[yearKey][key] !== 0) {
										options.push(key);
									}
								});
							}
						});
					});
				}
			});
			const uniqueOptions = options
				?.filter((value, index) => options.indexOf(value) === index)
				?.map((option) => {
					return {
						label: option.charAt(0).toUpperCase() + option.slice(1),
						value: option,
					};
				});
			setFrequencyOptions(uniqueOptions);
			if (uniqueOptions?.length == 1) {
				setFrequency(uniqueOptions[0]);
			}
		}
	}, [activeYears, DetailsLoading]);

	useEffect(() => {
		if (propertyDetails?.payment_plans?.length) {
			if (activePatmentPlan) {
				setActiveYearNumber(1);
				setActiveYear(activePatmentPlan?.years[0]);
			}
		}
	}, [activePatmentPlan]);

	useEffect(() => {
		const data = propertyDetails?.images?.map((img, index) => {
			return {
				src: img.path,
				altText: `Slide ${index + 1}`,
				caption: `Slide ${index + 1}`,
			};
		});
		setItems(data);
	}, [propertyDetails]);

	const updateLocationPositions = (lat, lng) => {
		setPropertyDetails({ ...propertyDetails, ...{ lat, lng } });
	};

	const interestHandler = (id) => {
		const data = { unit_id: id };
		setInterestLoading(true);
		if (!isInterested()) {
			interestServices.createInterest(data).then((response) => {
				if (response && response.status === SuccessCreated) {
					toast.success("Unit Added to Your Interests Successfully");
					dispatch(
						addInterest({ interestsUnits: [...AuthData.interestsUnits, id] })
					);
					setInterestLoading(false);
				}
			});
		} else {
			interestServices.deleteInterest(data).then((response) => {
				if (response && response.status === SuccessOk) {
					toast.success("Unit removed from Your interests");
					const updatedInterests = AuthData.interestsUnits.filter(
						(data) => data !== propertyDetails?.id
					);
					dispatch(addInterest({ interestsUnits: updatedInterests }));
					setInterestLoading(false);
				}
			});
		}
	};

	useEffect(() => {
		if (filterData.from == "interactive") {
			window.scrollTo({
				top: 1450,
				left: 0,
				behavior: "smooth",
			});
		} else {
			window.scrollTo(0, 0);
		}

		return () => {
			dispatch(appendFilters({ from: "" }));
		};
	}, []);

	useEffect(() => {
		new InterActiveModeService()
			.getInteractiveModeSite(propertyDetails?.coumound?.id)
			.then((res) => {
				if (res?.data?.length) {
					const data = res.data[0];
					let check = data?.images?.find(
						(img) => img?.constrains?.id === propertyDetails?.id
					);
					// let info = data?.images?.find(item => !!item?.shapes?.filter(details=> details?.hotspot?.id === propertyDetails?.id).length)
					if (!!check) {
						const master = data?.images?.find(
							(item) => item?.image?.id === data?.main_image?.id
						);
						setHasInteractive(!!res.data?.length);
						dispatch(
							appendData({
								compound: modeData.compound,
								currentImge: {
									id: master?.image?.id,
									path: master?.image?.path,
								},
								masterImg: {
									id: master?.image?.id,
									path: master?.image?.path,
								},
								// images: [
								//   {...info, ...info?.image, comesForm: {id: "", path: ""}, image: null, shapes: info.shapes?.filter(item=> item?.hotspot?.id === propertyDetails?.id)},
								//   master
								// ]
								images: res.data[0]?.images?.map((img) => ({
									...img,
									...img?.image,
									image: null,
								})),
							})
						);
					}
					// const data = res.data[0]
					// const master = data?.images?.find(item => item?.image?.id === data?.main_image?.id)
					// dispatch(appendData({
					//         compound: modeData.compound,
					//         currentImge: {
					//             id: master?.image?.id,
					//             path: master?.imagepath
					//         },
					//         masterImg: {
					//             id: master?.image?.id,
					//             path: master?.image?.path
					//         },
					//         images: res.data[0]?.images?.map(img => ({
					//             ...img,
					//             ...img?.image,
					//             image: null

					//         }))
					//     }
					// ))
				}
			});
	}, [propertyDetails]);

	if (DetailsLoading) {
		return <Skeleton.ProprtyDetails history={props.history} />;
	}

	if (notFound) {
		return (
			<div className="websitPages pt-10rem">
				<MetaTags>
					<title>Property Details</title>
				</MetaTags>
				<Container fluid className="px-lg-5 px-3 pb-5 pt-4">
					<Card>
						<CardBody>
							<CardText className="text-center h2">
								{t("Compound not found")}
							</CardText>
							<CardText className="text-center">
								<Link to={"/"} className="btn btn-primary mt-3">
									{t("Back to home page")}
								</Link>
							</CardText>
							<CardImg
								src={imgError}
								className="img-fluid w-50 m-auto d-block"
							/>
						</CardBody>
					</Card>
				</Container>
			</div>
		);
	}
	return (
		<div className="websitPages properties-details pt-10rem">
			<MetaTags>
				<title>Property Details</title>
			</MetaTags>
			<div>
				<Container fluid className="px-lg-5 px-3 pb-5 pt-4">
					<p
						className="page-title"
						dangerouslySetInnerHTML={{
							__html: t("Property Details"),
						}}></p>

					<Row className="property-images">
						{items && items?.length >= 1 && (
							<Col md={3}>
								<img
									src={items[0]?.src}
									alt={items[0]?.altText}
									onClick={() => setAlbumModal(true)}
									className="w-100 first-col"
								/>
							</Col>
						)}
						{items && items?.length >= 2 && (
							<Col md={3}>
								{items?.length >= 2 && (
									<img
										src={items[1]?.src}
										alt={items[1]?.altText}
										onClick={() => setAlbumModal(true)}
										className="w-100 second-col first"
									/>
								)}
								{items?.length >= 3 && (
									<img
										src={items[2]?.src}
										alt={items[2]?.altText}
										onClick={() => setAlbumModal(true)}
										className="w-100 second-col second"
									/>
								)}
							</Col>
						)}
						{items && items?.length >= 4 && (
							<Col md={3}>
								<img
									src={items[3]?.src}
									alt={items[3]?.altText}
									onClick={() => setAlbumModal(true)}
									className="w-100 first-col"
								/>
							</Col>
						)}
						{items && items?.length >= 5 && (
							<Col md={3}>
								{items?.length >= 4 && (
									<img
										src={items[4]?.src}
										alt={items[4]?.altText}
										onClick={() => setAlbumModal(true)}
										className="w-100 second-col second"
									/>
								)}
								{items?.length >= 6 && (
									<div className="last" onClick={() => setAlbumModal(true)}>
										<img
											src={items[5]?.src}
											alt={items[5]?.altText}
											className="w-100 second-col"
										/>
									</div>
								)}
							</Col>
						)}
						{albumModal && (
							<AlbumModal
								albumModal={albumModal}
								setAlbumModal={setAlbumModal}
								images={items}
							/>
						)}
						{propertyDetails && propertyDetails?.images.length === 0 && (
							<Col md={12}>
								<img src={compoundImg} className="img-responsive2" />
							</Col>
						)}
					</Row>

					<Row className="pt-4">
						<Col lg={9} md={8}>
							<p className="text-color m-0 font-size-32 fw-bold">
								{propertyDetails?.name[`${AuthData.lang}`]
									? propertyDetails?.name[`${AuthData.lang}`]
									: propertyDetails?.name?.en}
							</p>
							<p className="text-color mb-0 font-size-16">
								{propertyDetails?.address[`${AuthData.lang}`]
									? propertyDetails?.address[`${AuthData.lang}`]
									: propertyDetails?.address?.en}
								,
								{propertyDetails?.area?.name[`${AuthData.lang}`]
									? propertyDetails?.area?.name[`${AuthData.lang}`]
									: propertyDetails?.area?.name?.en}
								,
								{propertyDetails?.city?.name[`${AuthData.lang}`]
									? propertyDetails?.city?.name[`${AuthData.lang}`]
									: propertyDetails?.city?.name?.en}
							</p>
							<p className="text-color m-0 fw-bold font-size-14">
								{propertyDetails?.unit_type?.name[`${AuthData.lang}`]
									? propertyDetails?.unit_type?.name[`${AuthData.lang}`]
									: propertyDetails?.unit_type?.name?.en}
							</p>
							<p className="fw-bold text-primary m-0 font-size-14">
								{exchangeRate?.symbol === "*"
									? toCurrency(
											propertyDetails.price * exchangeRate?.exchange_rate
									  )
									: toCurrency(
											propertyDetails.price / exchangeRate?.exchange_rate
									  )}{" "}
								{currency?.currency_code}{" "}
								<span className="text-muted font-size-14 font-weight-normal">
									{propertyDetails?.payment_method === "Cash" && t("only cash")}
								</span>
							</p>

							<p className="font-size-16 mb-0 mt-3 text-color">
								{!!propertyDetails?.other && (
									<>
										{Object.keys(propertyDetails?.other)?.map((key) => {
											if (
												propertyDetails?.other[key] == 0 ||
												propertyDetails?.other[key] == null
											) {
												return;
											}
											return (
												<p className="mb-1">
													{key}: <b>{propertyDetails?.other[key]}</b>
												</p>
											);
										})}
									</>
								)}
							</p>
						</Col>
						<Col lg={3} md={4}>
							<div className="text-center mt-3">
								<Link
									to={`/property-details/${id}/details`}
									style={{
										background: "var(--primary-color)",
										borderColor: "var(--primary-color)",
										borderRadius: "25px",
									}}
									className="w-100 py-2 btn btn-primary text-white font-size-16 text-center">
									{t("Buy Now")}
								</Link>
							</div>
							<div className="mt-3 text-center">
								<div className="d-flex justify-content-between mt-2 gap-2">
									<button
										onClick={() => setCallModal(true)}
										className="d-flex gap-2 w-100 rounded-4 justify-content-center px-3 py-2 align-items-center border-0 text-white"
										style={{
											background: "var(--primary-color)",
											fontSize: "14px",
										}}>
										<i className="fa fa-phone" /> {t("call")}
									</button>
									<button
										onClick={() => setMessageModal(true)}
										className="d-flex gap-2 w-100 rounded-4 justify-content-center px-3 py-2 align-items-center border-0 text-white"
										style={{
											background: "var(--primary-color)",
											fontSize: "14px",
										}}>
										<i className="fa fa-envelope" /> {t("Message")}
									</button>
								</div>
							</div>
							{/* <Card>
								<CardBody>
									<Media>
										{propertyDetails?.developer?.media?.path ? (
											<img
												src={propertyDetails.developer.media.path}
												className="pe-2"
												width="60"
												height="40"
											/>
										) : (
											<img src={developerdImg} className="pe-2" height="40" />
										)}
										<Media body>
											<span className="text-muted mb-0 mx-3">
												{t("hosted in")}{" "}
												{new Date(
													propertyDetails?.created_at
												).toLocaleDateString(`${AuthData.lang}`, options)}
											</span>
											<h5 className="font-size-16 mb-1 mx-3">
												{propertyDetails?.developer?.name[`${AuthData.lang}`]
													? propertyDetails?.developer?.name[`${AuthData.lang}`]
													: propertyDetails?.developer?.name?.en}
											</h5>
										</Media>
									</Media>
									<hr />
									<CardText tag="h6" className="pb-2">
										<img src={devCompound} className="pe-2" height="25" />
										<span>
											{" "}
											{propertyDetails?.developer?.compounds_count}{" "}
											{t("compounds")}
										</span>
									</CardText>
									<CardText tag="h6" className="pb-2">
										<img src={devBuilding} className="pe-2" height="25" />
										<span>
											{" "}
											{propertyDetails?.developer?.buildings_count}{" "}
											{t("buildings")}
										</span>
									</CardText>
									<CardText tag="h6" className="pb-2">
										<img src={devProperty} className="pe-2" height="25" />
										<span>
											{" "}
											{propertyDetails?.developer?.units_count} {t("property")}
										</span>
									</CardText>
									<div className="d-flex py-3">
										<div className=" w-100">
											<button
												className="w-100 btn btnCall text-center"
												onClick={() => setCallModal((c) => !c)}>
												<i className="fas fa-phone-alt"></i> {t("call")}
											</button>
										</div>
										<div className=" w-100 mx-2">
											<button
												className="w-100 btn btnMessage  text-center"
												onClick={() => setMessageModal((c) => !c)}>
												<i className="fa fa-envelope"></i>
											</button>
										</div>
										{interestLoading ? (
											<div className="w-100 d-flex justify-content-center pt-2">
												<Spinner size="sm" color="primary" />
											</div>
										) : (
											<div className="w-100">
												<button
													className="w-100 btn btnMessage text-center"
													onClick={() => {
														interestHandler(propertyDetails.id);
													}}>
													{isInterested() ? (
														<i className="fas fa-heart text-danger"></i>
													) : (
														<i className="far fa-heart text-danger"></i>
													)}
												</button>
											</div>
										)}
										<div className="mx-2 w-100">
											<ReactWhatsapp
												number={
													propertyDetails?.sales_rep?.phone?.includes("+")
														? propertyDetails?.sales_rep?.phone
														: `+2${propertyDetails?.sales_rep?.phone}`
												}
												class="btn btnMessage w-100"
												message="">
												<img src={whatsapp} alt="whatsapp" width="20" />
											</ReactWhatsapp>
										</div>
									</div>
								</CardBody>
							</Card> */}
						</Col>
					</Row>

					<div className="mt-5">
						<CardText
							tag="h3"
							className="text-primary font-size-32 bask-font py-2 fw-bold ">
							{t("Description")}
						</CardText>
						<p className="font-size-16 m-0 text-color">
							{propertyDetails?.description[`${AuthData.lang}`]
								? propertyDetails?.description[`${AuthData.lang}`]
								: propertyDetails?.description?.en}
						</p>
					</div>
					<div className="mt-5 mb-5">
						<h3 className="text-primary font-size-32 fw-bold mb-3 ">
							{t("Property Amenities")}
						</h3>
						<Row>
							<Col xl={3} lg={3} md={4} xs={12}>
								<div className="mb-3">
									<Media>
										<Media body>
											<p>{t("property type")}</p>
											<h5>
												{propertyDetails?.unit_type?.name[`${AuthData.lang}`]
													? propertyDetails?.unit_type?.name[`${AuthData.lang}`]
													: propertyDetails?.unit_type?.name?.en}
											</h5>
										</Media>
									</Media>
								</div>
							</Col>
							<Col xl={3} lg={3} md={4} xs={12}>
								<div className="mb-3">
									<Media>
										<Media body>
											<p> {t("area")}</p>
											<h5>{propertyDetails?.area?.name[`${AuthData.lang}`]}</h5>
										</Media>
									</Media>
								</div>
							</Col>
							{!!propertyDetails?.floor && (
								<Col xl={3} lg={3} md={4} xs={12}>
									<div className="mb-3">
										<Media>
											<Media body>
												<p>{t("Floor No.")}</p>
												<h5>{propertyDetails?.floor}</h5>
											</Media>
										</Media>
									</div>
								</Col>
							)}
							{!!propertyDetails?.size && (
								<Col xl={3} lg={3} md={4} xs={12}>
									<div className="mb-3">
										<Media>
											<Media body>
												<p>{t("Built Up Area")}</p>
												<h5>
													{parseFloat(propertyDetails?.size).toFixed(0)}{" "}
													{t("sqm")}
												</h5>
											</Media>
										</Media>
									</div>
								</Col>
							)}
							{propertyDetails?.sizes?.map((size, index) => {
								if (!size?.value) return;
								return (
									<Col key={index} xl={3} lg={3} md={4} xs={12}>
										<div className="mb-3">
											<Media>
												<Media body>
													<p>{size?.label}</p>
													<h5>
														{parseFloat(size?.value).toFixed(0)} {t("sqm")}
													</h5>
												</Media>
											</Media>
										</div>
									</Col>
								);
							})}
							{!!propertyDetails.bedrooms && (
								<Col xl={3} lg={3} md={4} xs={12}>
									<div className="mb-3">
										<Media>
											<Media body>
												<p>{t("No. of Bedrooms")}</p>
												<h5>
													{propertyDetails.bedrooms} {t("Bedrooms")}
												</h5>
											</Media>
										</Media>
									</div>
								</Col>
							)}
							{!!propertyDetails.bathrooms && (
								<Col xl={3} lg={3} md={4} xs={12}>
									<div className="mb-3">
										<Media>
											<Media body>
												<p>{t("No. of Bathrooms")}</p>
												<h5>
													{propertyDetails.bathrooms} {t("Bathrooms")}
												</h5>
											</Media>
										</Media>
									</div>
								</Col>
							)}
							{!!propertyDetails.finishing_type?.name[`${AuthData.lang}`] && (
								<Col xl={3} lg={3} md={4} xs={12}>
									<div className="mb-3">
										<Media>
											<Media body>
												<p>{t("finishing")}</p>
												<h5>
													{propertyDetails.finishing_type?.name[
														`${AuthData.lang}`
													]
														? propertyDetails.finishing_type?.name[
																`${AuthData.lang}`
														  ]
														: propertyDetails.finishing_type?.name?.en}
												</h5>
											</Media>
										</Media>
									</div>
								</Col>
							)}
							<Col xl={3} lg={3} md={4} xs={12}>
								<div className="mb-3">
									<Media>
										<Media body>
											<p>{t("payment type")}</p>
											<h5>
												{propertyDetails?.payment_method === "Cash"
													? t("only cash")
													: t("installment")}
											</h5>
										</Media>
									</Media>
								</div>
							</Col>

							{!!propertyDetails.amenities?.length &&
								propertyDetails?.amenities?.map((amenity, index) => {
									return (
										<Col key={index} xl={3} lg={3} md={4} xs={12}>
											<div className="mb-3">
												<Media>
													<Media body>
														<p>{`Amenity ${index + 1}`}</p>
														<h5>
															{!!amenity?.name[AuthData?.lang]
																? amenity?.name[AuthData?.lang]
																: amenity?.name?.en}
														</h5>
													</Media>
												</Media>
											</div>
										</Col>
									);
								})}
						</Row>
					</div>

					{/* Videos */}
					{propertyDetails && propertyDetails?.videos?.length !== 0 && (
						<div>
							<Carousel
								className="pb-3 mb-4"
								swipeable={true}
								draggable={true}
								showDots={true}
								responsive={videoResponsive}
								infinite={false}
								autoPlaySpeed={1000}
								keyBoardControl={true}
								customTransition="all .5"
								transitionDuration={500}
								customRightArrow={<CustomRight />}
								customLeftArrow={<CustomLeft />}
								containerClass="carousel-container w-100 videos-carousel"
								removeArrowOnDeviceType={[]}
								dotListClass="custom-dot-list-style"
								itemClass="carousel-item-padding-40-px">
								{propertyDetails?.videos?.map((video, index) => {
									return (
										<video key={index} controls>
											<source src={video?.path} type="video/mp4" />
										</video>
									);
								})}
							</Carousel>
						</div>
					)}

					{/* Interactive */}
					{hasInteractive && (
						<div className="mt-5 property-interactive">
							<div>
								<CardText tag="h3" className="text-primary fw-bold">
									{t("Buy your Unit Inside Project")}
								</CardText>
								<span className="mt-1 my-2">{t("interactive subtitle")}</span>

								<Row>
									<Col lg="12" className="position-relative">
										{modeData?.masterImg?.path && (
											<div
												id="interactive"
												className="position-relative mt-3 "
												style={{ height: "30rem", objectFit: "cover" }}>
												<div
													className="shape-container"
													style={{
														border: showHighlight
															? "2px #0d6efd solid"
															: "2px transparent solid",
														background: showHighlight
															? "rgba(250, 76, 31, .3)"
															: "none",
													}}>
													<div
														className="mouse_container-web"
														onClick={() => {
															if (!loadingInteractive && loadedMasterImg) {
																document.body.style.overflow = "hidden";
																setShowInteractive(true);
															}
														}}>
														{loadingInteractive ? (
															<Spinner2></Spinner2>
														) : (
															<>
																<i className="fas fa-mouse-pointer fa-3x text-white"></i>
																<span className="d-block fw-bold text-white font-size-32 bask-font text-center">
																	Drag and Scroll
																</span>
															</>
														)}
													</div>
												</div>
												<img
													style={{
														borderRadius: "10px",
														padding: 0,
														width: "100%",
														height: "100%",
													}}
													onClick={() => {
														setshowHighlight(true);
														setTimeout(() => {
															setshowHighlight(false);
														}, 250);
													}}
													onLoad={() => {
														if (!loadingInteractive && showInteractive) {
															document.body.style.overflow = "hidden";
															setShowInteractive(true);
														}
														setLoadedMasterImg(true);
													}}
													src={modeData?.masterImg?.path}
												/>
											</div>
										)}
									</Col>
								</Row>
								{!loadingInteractive && showInteractive && (
									<InteractiveMode
										developer={propertyDetails?.developer}
										allUnits={[]}
										propertyDetails={propertyDetails}
										city={propertyDetails?.city?.name}
										setFullScreen={() => {}}
										setShowInteractive={setShowInteractive}
										address={propertyDetails?.address}
										history={props.history}
										compound={propertyDetails.compound}
										area={propertyDetails?.area?.name}
									/>
								)}
							</div>
						</div>
					)}

					{/* Payment Plan */}
					<div className="mt-5">
						<div>
							<h3
								className="text-primary font-size-32 fw-bold mb-2"
								dangerouslySetInnerHTML={{
									__html: t("payment plans title"),
								}}></h3>
							<p className="text-color pb-3 font-size-16">
								{t("payment subtitle")}
							</p>
						</div>
						{propertyDetails?.payment_method === "Cash" ? (
							<div className="p-4">
								<CardText
									tag="h4"
									className="fw-bold mt-1 mb-0 mx-3"
									style={{ color: "#808080" }}>
									{t("only cash")}
								</CardText>
							</div>
						) : (
							<div className="payment-table">
								<Row>
									<Col md={8}>
										{propertyDetails?.payment_plans?.map((plan, index) => {
											return (
												<button
													key={index}
													className="btn btnSecondary px-4 py-2 mx-1 my-1"
													style={{
														background:
															activeYears == index
																? "var(--primary-color)"
																: "#f4f4f4",
														color: activeYears == index ? "#FFF" : "#495057",
													}}
													onClick={() => {
														setDepositIndex(index);
														setActivePatmentPlan(plan);
														setActiveYears(index);
													}}>
													{plan.years.length} {t("years")}
												</button>
											);
										})}
										{/* <button className="btn btnSecondary px-4 py-3 me-2">Cash</button> */}
									</Col>
								</Row>
								<Row>
									{activeYears !== -1 && (
										<Row>
											<Col md={4} className="mt-3 mb-3">
												<label className="text-primary">
													Select Payment Frequency
												</label>
												<Select
													options={frequencyOptions}
													value={frequency}
													onChange={(e) => {
														setFrequency(e);
													}}
												/>
											</Col>
										</Row>
									)}
									{activeYears !== -1 &&
										(!!frequency?.label || frequency?.length == 1) && (
											<Col lg={3} md={4}>
												<Nav tabs className="d-block tabPayment mt-3">
													{activePatmentPlan?.years?.length > 0 &&
														activePatmentPlan.years.map((year, index) => {
															return (
																<NavItem>
																	<NavLink
																		className={classnames({
																			active: activeYearNumber === index + 1,
																		})}
																		onClick={() => {
																			setActiveYearNumber(index + 1);
																			setActiveYear(year);
																		}}>
																		<div className="d-flex">
																			<div className="w-100">
																				<CardText
																					tag="p"
																					className="font-size-12 mb-1">
																					{t("Year Number")}
																				</CardText>
																				<CardText
																					tag="p"
																					className="fw-bold font-size-16 mb-1">
																					{index == 0 && (
																						<>
																							{index + 1}
																							{t("st Year")}
																						</>
																					)}
																					{index == 1 && (
																						<>
																							{index + 1}
																							{t("nd Year")}
																						</>
																					)}
																					{index == 2 && (
																						<>
																							{index + 1}
																							{t("rd Year")}
																						</>
																					)}
																					{index >= 3 && (
																						<>
																							{index + 1}
																							{t("th Year")}
																						</>
																					)}
																				</CardText>
																			</div>
																			<div className="w-100">
																				<CardText
																					tag="p"
																					className="font-size-12 mb-1">
																					{t("payable")}
																				</CardText>

																				{index === 0 ? (
																					<CardText
																						tag="p"
																						className="fw-bold font-size-16 mb-1">
																						{exchangeRate?.symbol === "*"
																							? toCurrency(
																									year?.total *
																										exchangeRate?.exchange_rate
																							  )
																							: toCurrency(
																									year?.total /
																										exchangeRate?.exchange_rate
																							  )}{" "}
																						{currency?.currency_code}
																					</CardText> //+ activePatmentPlan.down_payment
																				) : (
																					<CardText
																						tag="p"
																						className="fw-bold font-size-16 mb-1">
																						{exchangeRate?.symbol === "*"
																							? toCurrency(
																									year?.total *
																										exchangeRate?.exchange_rate
																							  )
																							: toCurrency(
																									year?.total /
																										exchangeRate?.exchange_rate
																							  )}{" "}
																						{currency?.currency_code}
																					</CardText>
																				)}
																			</div>
																		</div>
																	</NavLink>
																</NavItem>
															);
														})}
												</Nav>
											</Col>
										)}
									<Col lg={9} md={8}>
										{activeYears !== -1 &&
											(!!frequency?.label || frequency?.length == 1) && (
												<Row id="payment">
													<TablePayment
														totalOffPayments={totalOffPayments}
														activeYearNumber={activeYearNumber}
														frequency={frequency}
														activeYear={activeYear}
														exchangeRate={exchangeRate}
														downPayment={{
															down_payment: activePatmentPlan.down_payment,
															down_payment_amount:
																activePatmentPlan?.down_payment_amount,
														}}
													/>
												</Row>
											)}
									</Col>
									{activePatmentPlan?.link_down_payment &&
										!!activePatmentPlan?.elevate_down_payment?.length && (
											<Col lg={12} md={12} className="mb-2">
												<p
													className="btn btnSecondary px-4 py-3 mx-1 my-1"
													style={{
														background: "none",
														color:
															activeElevate?.down_payment == 0
																? "#556EE5"
																: "#000",
														border: "1px solid",
														borderColor:
															activeElevate?.down_payment == 0
																? "#556EE5"
																: "#000",
													}}
													onClick={() => {
														setActiveElevate({ down_payment: 0, discount: 0 });
													}}>
													<p
														className="mb-0"
														style={{ height: "39px", lineHeight: "3" }}>
														Default
													</p>
												</p>
												{activePatmentPlan?.elevate_down_payment?.map(
													(elv, ind) => {
														return (
															<p
																key={ind}
																className="btn btnSecondary px-4 py-3 mx-1 my-1"
																style={{
																	background: "none",
																	color:
																		activeElevate?.down_payment ==
																		elv?.down_payment
																			? "#556EE5"
																			: "#000",
																	border: "1px solid",
																	borderColor:
																		activeElevate?.down_payment ==
																		elv?.down_payment
																			? "#556EE5"
																			: "#000",
																}}
																onClick={() => {
																	setActiveElevate(elv);
																}}>
																<p className="mb-0">
																	Down Payment {elv?.down_payment}%
																</p>
																<p className="mb-0">
																	Discount {elv?.discount}%
																</p>
															</p>
														);
													}
												)}
											</Col>
										)}
								</Row>
								<Row
									className="mx-1"
									style={{
										background: "var(--bg-color)",
										borderRadius: "25px",
									}}>
									<Col md={9}>
										{/* {activeYears !== -1 &&<CardText className='font-size-16 mb-2' style={{ color: "#3a3335" }}>
                            <p className='text-muted font-size-14 mb-0 pt-1'> {t("Deposit")}</p>
                            <span className="fw-bold">{toCurrency(propertyDetails ?.payment_plans[depositIndex]?.depost)} {currency?.currency_code}</span>
                          </CardText>} */}
										{activeYears !== -1 && (
											<>
												<Row>
													<Col md={6} className="mb-3">
														<CardText
															tag="p"
															className="text-color font-size-14 pt-3 mb-1">
															{t("Original Price")}
														</CardText>
														<CardText
															tag="h6"
															className="text-primary font-size-16">
															{exchangeRate?.symbol === "*"
																? toCurrency(
																		activePatmentPlan?.total *
																			exchangeRate?.exchange_rate
																  )
																: toCurrency(
																		activePatmentPlan?.total /
																			exchangeRate?.exchange_rate
																  )}{" "}
															{currency?.currency_code}
														</CardText>
													</Col>
													<Col md={6} className="mb-3">
														<CardText className="font-size-16 mb-2 pt-3">
															<p className="text-color font-size-14 mb-0 pt-1">
																{" "}
																{t("Depost")}
															</p>
															<span className="fw-bold text-primary">
																{exchangeRate?.symbol === "*"
																	? toCurrency(
																			activePatmentPlan?.depost *
																				exchangeRate?.exchange_rate
																	  )
																	: toCurrency(
																			activePatmentPlan?.depost /
																				exchangeRate?.exchange_rate
																	  )}{" "}
																{currency?.currency_code}
															</span>
														</CardText>
													</Col>
													{activePatmentPlan?.link_down_payment &&
														!!activeElevate?.down_payment && (
															<Col md={6} className="mb-3">
																<CardText className="font-size-16 mb-2">
																	<p className="text-color font-size-14 mb-0 pt-1">
																		{" "}
																		{t("Down Payment")}
																	</p>
																	<span className="fw-bold text-primary">
																		{exchangeRate?.symbol === "*"
																			? toCurrency(
																					activePatmentPlan?.total *
																						(activeElevate?.down_payment /
																							100) *
																						exchangeRate?.exchange_rate
																			  )
																			: toCurrency(
																					(activePatmentPlan?.total *
																						(activeElevate?.down_payment /
																							100)) /
																						exchangeRate?.exchange_rate
																			  )}
																		{currency?.currency_code}
																	</span>
																	{/* <span className="fw-bold">{toCurrency(propertyDetails?.cash_amount)} {currency?.currency_code}</span> */}
																	<span
																		className="fw-bold"
																		style={{
																			color: "rgb(255, 255, 255)",
																			background: "rgb(85, 110, 230)",
																			marginLeft: "24px",
																			borderRadius: "8px",
																			fontSize: "15px",
																			padding: "2px 7px",
																		}}>
																		{toCurrency(activeElevate?.down_payment)}%
																		{/* {toCurrency(propertyDetails?.cash)}% */}
																	</span>
																</CardText>
															</Col>
														)}
													{activePatmentPlan?.link_down_payment &&
														!!activeElevate?.down_payment && (
															<Col md={6}>
																<CardText
																	className="font-size-16 mb-2"
																	style={{ color: "#3a3335" }}>
																	<p className="text-muted font-size-14 mb-0">
																		{" "}
																		{t("Discount Amount")}
																	</p>
																	<span className="fw-bold">
																		{exchangeRate?.symbol === "*"
																			? toCurrency(
																					activePatmentPlan?.total *
																						(activeElevate?.discount / 100) *
																						exchangeRate?.exchange_rate
																			  )
																			: toCurrency(
																					(activePatmentPlan?.total *
																						(activeElevate?.discount / 100)) /
																						exchangeRate?.exchange_rate
																			  )}
																		{currency?.currency_code}
																	</span>
																	<span
																		className="fw-bold"
																		style={{
																			color: "rgb(255, 255, 255)",
																			background: "rgb(85, 110, 230)",
																			marginLeft: "24px",
																			borderRadius: "8px",
																			fontSize: "15px",
																			padding: "2px 7px",
																		}}>
																		{toCurrency(activeElevate?.discount)}%
																	</span>
																</CardText>
															</Col>
														)}
													{activePatmentPlan?.link_down_payment &&
														!!activeElevate?.down_payment && (
															<Col md={6}>
																<CardText
																	className="font-size-16 mb-2"
																	style={{ color: "#3a3335" }}>
																	<p className="text-muted font-size-14 mb-0 pt-1">
																		{" "}
																		{t("Price After Discount")}
																	</p>
																	<span>
																		<span
																			style={{
																				textDecoration: "line-through",
																			}}>
																			{exchangeRate?.symbol === "*"
																				? toCurrency(
																						activePatmentPlan?.total *
																							exchangeRate?.exchange_rate
																				  )
																				: toCurrency(
																						activePatmentPlan?.total /
																							exchangeRate?.exchange_rate
																				  )}{" "}
																			{currency?.currency_code}
																		</span>
																		<span className="fw-bold text-primary mx-2">
																			{exchangeRate?.symbol === "*"
																				? toCurrency(
																						(parseFloat(
																							activePatmentPlan?.total
																						) -
																							parseFloat(
																								activePatmentPlan?.total *
																									(activeElevate?.discount /
																										100)
																							)) *
																							exchangeRate?.exchange_rate
																				  )
																				: toCurrency(
																						(parseFloat(
																							activePatmentPlan?.total
																						) -
																							parseFloat(
																								activePatmentPlan?.total *
																									(activeElevate?.discount /
																										100)
																							)) /
																							exchangeRate?.exchange_rate
																				  )}{" "}
																			{currency?.currency_code}
																		</span>
																	</span>
																</CardText>
															</Col>
														)}
												</Row>
											</>
										)}
									</Col>
									<Col
										md={3}
										className="d-flex align-items-end justify-content-end">
										<div className="w-100 p-3">
											<Link
												to={`/property-details/${id}/details`}
												style={{
													background: "var(--primary-color)",
													borderColor: "var(--primary-color)",
													borderRadius: "25px",
												}}
												className="w-100 btn btn-primary fw-bold text-white font-size-16 text-center">
												{t("Buy Now")}
											</Link>
										</div>
									</Col>
								</Row>
							</div>
						)}
					</div>

					{!!mapRender && (
						<div className="mt-5">
							<p className="bask-font text-primary font-size-32 mb-2">
								{"location"}
							</p>
							<div>
								<MyMap
									updateLocationPositions={() => {}}
									lat={Number(propertyDetails.coumound.lat)}
									lng={Number(propertyDetails.coumound.lang)}
								/>
							</div>
						</div>
					)}

					{propertyDetails?.videos?.length !== 0 && (
						<Card>
							<h3 className="text-primary ms-2 mb-0 mt-3 p-2 fw-bold">
								{t("Video")}
							</h3>
							<CardBody>
								{propertyDetails?.videos?.map((video, index) => {
									return (
										<div className="mb-3">
											<video
												style={{
													display: "block",
													width: "100%",
												}}
												controls>
												<source src={video.path} type="video/mp4" />
											</video>
										</div>
									);
								})}
							</CardBody>
						</Card>
					)}
				</Container>

				{callModal && (
					<CallModal
						modal={callModal}
						setModal={setCallModal}
						phone={propertyDetails?.sales_rep?.phone}
					/>
				)}
				{messageModal && (
					<MessageModal
						modal={messageModal}
						setModal={setMessageModal}
						item={propertyDetails}
						type="unit"
					/>
				)}
			</div>
		</div>
	);
};

const CustomRight = ({ onClick }) => (
	<button onClick={onClick} className="arrow right border-0">
		<i className="fas fa-arrow-right fa-1x"></i>
	</button>
);
const CustomLeft = ({ onClick }) => (
	<button onClick={onClick} className="arrow left border-0">
		<i className="fas fa-arrow-left fa-1x"></i>
	</button>
);

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number.toFixed(1));
};

export default PropertyDetails;
